module.exports = __webpack_public_path__ + "img/IMG_0787.67b2a853.jpg";